import React from 'react';
import { IonApp, IonContent, IonPage } from '@ionic/react';
import { Helmet } from 'react-helmet-async';
import Header from 'layouts/Header';
// Reuse the Privacy/Terms page styling for a consistent legal-page look.
import '../PrivacyPage/PrivacyPage.css';

// The third-party sub-processors Zibby uses to operate the platform. Keep this
// in sync with what we actually use — Slack (and other reviews) link here, and
// it's a public attestation. Add a row BEFORE engaging a new sub-processor that
// processes Customer Data.
const SUBPROCESSORS = [
  {
    name: 'Amazon Web Services (AWS)',
    purpose: 'Cloud infrastructure, data storage, and compute (database, object storage, serverless, containers)',
    location: 'United States; Australia (ap-southeast-2)',
  },
  {
    name: 'Anthropic',
    purpose: 'LLM inference (Claude) powering AI agents',
    location: 'United States',
  },
  {
    name: 'OpenAI',
    purpose: 'LLM inference (GPT / Codex) when selected by the customer',
    location: 'United States',
  },
  {
    name: 'Stripe',
    purpose: 'Billing and payment processing',
    location: 'United States',
  },
  {
    name: 'PostHog',
    purpose: 'Product analytics',
    location: 'United States',
  },
];

const cell = {
  padding: '10px 14px',
  borderBottom: '1px solid rgba(0,0,0,0.08)',
  textAlign: 'left',
  verticalAlign: 'top',
  fontSize: '15px',
  lineHeight: 1.5,
};
const headCell = { ...cell, fontWeight: 600, borderBottom: '2px solid rgba(0,0,0,0.15)' };

const SubProcessorsPage = () => {
  return (
    <IonApp>
      <Helmet>
        <title>Sub-processors - Teamy</title>
        <meta
          name="description"
          content="The third-party sub-processors Teamy uses to provide and operate its AI agent platform."
        />
      </Helmet>
      <IonPage>
        <Header user={null} />
        <IonContent className="privacy-ion-content">
          <div className="privacy-page">
            <div className="privacy-container">
              <header className="privacy-header">
                <h1>Sub-processors</h1>
                <p className="last-updated">Last Updated: July 4, 2026</p>
              </header>

              <div className="privacy-content">
                <section className="privacy-section">
                  <p>
                    Zibby Labs (&quot;Teamy,&quot; &quot;we,&quot; &quot;our,&quot; or &quot;us&quot;) engages the
                    third-party sub-processors listed below to help provide and operate our AI agent platform. Each
                    sub-processor is bound by data-protection obligations consistent with this list and our{' '}
                    <a href="/privacy">Privacy Policy</a>.
                  </p>

                  <div style={{ overflowX: 'auto', margin: '20px 0' }}>
                    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                      <thead>
                        <tr>
                          <th style={headCell}>Sub-processor</th>
                          <th style={headCell}>Purpose</th>
                          <th style={headCell}>Processing location</th>
                        </tr>
                      </thead>
                      <tbody>
                        {SUBPROCESSORS.map((s) => (
                          <tr key={s.name}>
                            <td style={{ ...cell, fontWeight: 600, whiteSpace: 'nowrap' }}>{s.name}</td>
                            <td style={cell}>{s.purpose}</td>
                            <td style={cell}>{s.location}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <p>
                    Customers who connect their own provider API keys (BYOK) or third-party integrations may engage
                    additional providers under their own accounts; those providers are governed by the customer&apos;s
                    own agreements. We will update this page before engaging a new sub-processor that processes
                    Customer Data.
                  </p>
                </section>
              </div>
            </div>
          </div>
        </IonContent>
      </IonPage>
    </IonApp>
  );
};

export default SubProcessorsPage;
